import {
  INTERVIEWED_CANDIDATE_FETCHING,
  INTERVIEWED_CANDIDATE_FAILED,
  INTERVIEWED_CANDIDATE_SUCCESS,
} from "../actions/types";

const initialState = {
  result: null,
  isFetching: false,
  isError: false,
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case INTERVIEWED_CANDIDATE_FETCHING:
      return { ...state, result: null, isFetching: true, isError: false };
    case INTERVIEWED_CANDIDATE_FAILED:
      return { ...state, result: null, isFetching: false, isError: true };
    case INTERVIEWED_CANDIDATE_SUCCESS:
      return { ...state, result: payload, isFetching: false, isError: false };
    default:
      return state;
  }
}
